// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__FPgbB","top":"styles_top__3hEoY","left":"styles_left__2sjN7","description":"styles_description__2Ljki"};